import React from 'react';
import CreateClaimForm from '@/components/forms/CreateClaimForm';

export const CreateClaimPage = () => {
	return <CreateClaimForm />;
};